module.exports = __webpack_public_path__ + "img/icon_3.cb465398.png";